<div class="flex flex-col items-center justify-between md:flex-row">
  <div class="mb-6 text-primary-800 md:mb-0 md:mr-2">
    Serwis korzysta z plików cookies. Dalsze korzystanie z serwisu bez zmiany ustawień przeglądarki oznacza
    potwierdzenie zapoznania się z powyższą informacją i zgodę na wykorzystanie plików cookies na zasadach określonych w
    <a [href]="privacyPolicyLink" class="text-primary-600 underline transition-colors duration-150 hover:text-primary-500"
      >Polityce prywatności</a
    >
    przez administratora serwisu.
  </div>
  <button mat-flat-button color="primary" class="flex-shrink-0 ml-10 uppercase" (click)="close()">Rozumiem</button>
</div>
